import { NavigationReports } from "@components/widgets/AppSubNav";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { ProjectRevenue } from "@src/components/modules/reports/project/revenue";
import type { NavigationReportsProps } from "@src/components/widgets/AppSubNav/NavigationReports/NavigationReports";
import { DemoModule, Modules } from "@src/components/widgets/DemoModule";
import { createFileRoute } from "@tanstack/react-router";

const report: NavigationReportsProps["currentReport"] = {
  href: "/reports/invoiced-by-project",
  title: () => t`Project Billings`,
  isBeta: true,
};

const Page = () => (
  <MainLayout
    title={report.title()}
    navigation={<NavigationReports currentReport={report} />}
  >
    <DemoModule module={Modules.Reports}>
      <ProjectRevenue report={report} />
    </DemoModule>
  </MainLayout>
);

export const Route = createFileRoute("/reports/invoiced-by-project")({
  component: Page,
});
